var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagOman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0109C0 22.0756 3.37438 27.3518 8.34781 30.0654V1.9563C3.37438 4.66992 0 9.94617 0 16.0109Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0049 21.5759C31.648 19.8426 32 17.9679 32 16.0107C32 14.0536 31.648 12.1788 31.0049 10.4456H0.99525C0.352062 12.1788 0 14.0536 0 16.0107C0 17.9679 0.352062 19.8426 0.99525 21.5759L16 22.9672L31.0049 21.5759Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C22.8795 32.0107 28.7441 27.6687 31.0049 21.5759H0.995239C3.25586 27.6687 9.12062 32.0107 16 32.0107Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0108C0 23.4033 5.01381 29.6236 11.8261 31.4596V0.562012C5.01381 2.39801 0 8.61839 0 16.0108Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78814 7.05162L8.31245 5.57593L7.3287 6.5598L6.34495 5.57593L4.86927 7.05162L5.85308 8.03543L4.86914 9.0193L6.34483 10.495L7.32864 9.51112L8.31245 10.495L9.78814 9.0193L8.80433 8.03543L9.78814 7.05162Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOman);
export default __webpack_public_path__ + "static/media/flag_oman.68b21e3915105ecd44850d335c69ba4e.svg";
export { ForwardRef as ReactComponent };